import { useParams } from 'react-router-dom';
import { NotFound } from 'app/agriculture/routes/NotFound';
import { TaskDeleteDialog } from 'app/agriculture/routes/Tasks/TaskDelete/components/TaskDeleteDialog';

export function TaskDelete() {
    const { id } = useParams();
    if (!id) return <NotFound />;

    return <TaskDeleteDialog taskId={id} />;
}
